"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import * as React from "react";

import { createSVGIcon } from "./util";

/**
 * TODO (jfangrad): Track and determine if used and where
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const ClockTruck = createSVGIcon(
  <>
    <path
      d="M5.317 15.767a1.233 1.233 0 1 0 2.467 0 1.233 1.233 0 0 0-2.467 0ZM13.334 15.767a1.233 1.233 0 1 0 2.467 0 1.233 1.233 0 0 0-2.467 0ZM10.867 5.932a4.932 4.932 0 1 0-8.811 3.051M5.933 5.932l1.85-1.85"
      stroke="currentColor"
      strokeWidth="1.714"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.784 15.767H8.4v-4.934H6.55A2.467 2.467 0 0 0 4.084 13.3v2.467h1.233"
      stroke="currentColor"
      strokeWidth="1.714"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.8 15.767h1.234V9.6A1.233 1.233 0 0 0 15.8 8.367H9.634A1.233 1.233 0 0 0 8.4 9.6v6.167h4.934"
      stroke="currentColor"
      strokeWidth="1.714"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "ClockTruck",
  {
    viewBox: "0 0 18 18",
    fill: "none",
    className: legacyIconCls(),
  }
);
